<div class="dialog-container">
  <form [formGroup]="form">
    <kendo-dialog [minWidth]="250" [width]="500" [maxHeight]="700">
      <div class="k-bg-primary k-pt-2"></div>
      <div class="title k-px-8 k-py-6 k-d-flex k-justify-content-between">
        <p class="!k-m-0 k-font-semibold font-20"> {{isReview ? 'Review' : '' }} Request for Extension</p>
        <button kendoButton class="!k-p-0" fillMode="clear" (click)="close()" aria-label="Close"><fa-icon icon="xmark"
            class="fa-md"></fa-icon></button>
      </div>

      <div class="content k-px-8 k-d-flex k-flex-col gap-24">
        <div>
          <p class="!k-m-0 font-12 readonly-label">Assessment Name</p>
          <p class="!k-m-0">Psychoeducational Assessment</p>
        </div>
        <div>

          <p class="!k-m-0 font-12 readonly-label">Evaluation Due by Date</p>

          <p class="!k-m-0"></p>
        </div>
        <div class="k-d-flex">
          <kendo-floatinglabel text="Extension Days Needed">
            <kendo-numerictextbox formControlName="extensionDays" placeholder="1-30" [min]="1" [disabled]="isReview"
              format="##" [max]="30"></kendo-numerictextbox>
          </kendo-floatinglabel>
          <kendo-floatinglabel class="k-ml-4" text="Requested Due by Date">
            <kendo-datepicker calendarType="classic" placeholder="Choose a date ..." formControlName="requestedDueDate"
              [disabled]="true" [format]="format"></kendo-datepicker>
          </kendo-floatinglabel>
        </div>
        <div>
          <kendo-floatinglabel text="Reason for Extension" class="k-w-full">
            <kendo-dropdownlist rounded="large" [data]="[]" textField="description" valueField="id"
              formControlName="extensionReason" [disabled]="isReview">
            </kendo-dropdownlist>
          </kendo-floatinglabel>
        </div>
        <div>
          <kendo-floatinglabel text="Additional Information" class="k-w-full">
            <kendo-textarea rounded="large" [rows]="3" resizable="vertical" formControlName="extensionAdditionalInfo"
              [disabled]="isReview" />
          </kendo-floatinglabel>
        </div>

        <ng-container *ngIf="isReview">
          <span class="k-form-separator !k-m-0"></span>
          <kendo-buttongroup selection="single" rounded="large" class="k-w-full">
            <button kendoButton [toggleable]="true" (click)="onAction('approve')">Approve</button>
            <button kendoButton [toggleable]="true" (click)="onAction('reject')">Reject</button>
          </kendo-buttongroup>
          <div class="k-d-flex" *ngIf="form.get('action').value === approve">
            <kendo-floatinglabel text="Extension Days Approved">
              <kendo-numerictextbox formControlName="approvedDays" placeholder="1-30" format="##" [max]="30"
                [min]="1"></kendo-numerictextbox>
            </kendo-floatinglabel>
            <kendo-floatinglabel class="k-ml-4" text="New Due By Date">
              <kendo-datepicker calendarType="classic" placeholder="Choose a date ..." formControlName="newDueDate"
                [disabled]="true" [format]="format"></kendo-datepicker>
            </kendo-floatinglabel>
          </div>
          <div *ngIf="form.get('action').value === reject">
            <kendo-floatinglabel text="Reason for Rejection" class="k-w-full">
              <kendo-dropdownlist rounded="large" [data]="[]" textField="description" valueField="id"
                formControlName="rejectionReason">
              </kendo-dropdownlist>
            </kendo-floatinglabel>
          </div>
          <div *ngIf="form.get('action').value === reject">
            <kendo-floatinglabel text="Additional Information" class="k-w-full">
              <kendo-textarea rounded="large" [rows]="3" resizable="vertical"
                formControlName="rejectionAdditionalInfo" />
            </kendo-floatinglabel>
          </div>
        </ng-container>


        <button kendoButton class="k-w-full !k-mb-8" [disabled]="form?.invalid" themeColor="primary" size="medium"
          rounded="large" fillMode="outline">Submit</button>

      </div>
    </kendo-dialog>
  </form>
</div>